<div layout="column">
  <div class="logo-container" layout="column" layout-align="center center">
    <!-- <img src="http://via.placeholder.com/400x200?text=Company+Logo" /> -->
    <img src="assets/images/itf.png" />
  </div>
  @if (!renderPasswordResetForm) {
    <itfg-login-form></itfg-login-form>
  }

  @if (renderPasswordResetForm) {
    <itfg-reset-password-form [token]="resetPasswordToken"></itfg-reset-password-form>
  }
</div>